import React from 'react';

/**
 * TrendArrow Component
 *
 * Displays a visual indicator showing if a stat is above, below, or at season average
 * @param {Object} props
 * @param {'up'|'down'|'neutral'} props.trend - Trend direction
 * @param {string} props.className - Additional CSS classes
 */
const TrendArrow = ({ trend, className = '' }) => {
  const getArrowConfig = () => {
    switch (trend) {
      case 'up':
        return {
          icon: '↑',
          color: 'text-green-500',
          title: 'Above season average'
        };
      case 'down':
        return {
          icon: '↓',
          color: 'text-red-500',
          title: 'Below season average'
        };
      case 'neutral':
        return {
          icon: '→',
          color: 'text-gray-400',
          title: 'Near season average'
        };
      default:
        return {
          icon: '→',
          color: 'text-gray-400',
          title: 'Near season average'
        };
    }
  };

  const config = getArrowConfig();

  return (
    <span
      className={`inline-flex items-center ml-1 font-bold ${config.color} ${className}`}
      title={config.title}
      aria-label={config.title}
    >
      {config.icon}
    </span>
  );
};

export default TrendArrow;
